export default __webpack_public_path__ + "static/media/main2_xl.a87325d2.jpg";